import React from 'react'
import { Link } from 'gatsby'
import Obfuscate from 'react-obfuscate'
import Layout from '../components/layout'
import SEO from '../components/seo'

const ComputerConsultingPage = () => (
  <Layout>
    <SEO 
      title="Computer Consulting & IT Services"
      description="Lawall Service Corp. provides IT services for small to medium businesses in NY. Computer installation, network management, accounting software, and technical support since 1982."
      pathname="/computer-consulting/"
    />

    <div className="page-hero">
      <h1>Computer Consulting by Lawall Service Corp.</h1>
      <p className="hero-subtitle">
        Complete IT solutions for small to medium-sized businesses since 1982
      </p>
    </div>

    <section className="about-section">
      <h2>About Lawall Service Corp.</h2>
      <p>
        Lawall Service Corp. has been providing the small to medium-sized business market 
        with computer consulting services since 1982. As a QuickBooks ProAdvisor, 
        we specialize in helping businesses get the most out of their accounting software 
        with expert setup, training, and ongoing support.
      </p>
      <p>
        By leveraging our deep accounting knowledge, we provide comprehensive computerized 
        accounting solutions paired with world-class hardware, networking, and software. 
        Our integrated approach means you get one trusted partner for all your technology needs.
      </p>
    </section>

    <section className="services-section">
      <h2>IT Services We Provide</h2>
      <div className="services-grid">
        <div className="service-card">
          <h3>Hardware & Setup</h3>
          <ul>
            <li>Computer Installation</li>
            <li>Server Installation</li>
            <li>Network Hardware Setup</li>
            <li>POS Station Configuration</li>
          </ul>
        </div>
        <div className="service-card">
          <h3>Ongoing Support</h3>
          <ul>
            <li>Computer Maintenance</li>
            <li>Server Maintenance</li>
            <li>Network Management</li>
            <li>Help Desk Support</li>
          </ul>
        </div>
        <div className="service-card">
          <h3>Software Solutions</h3>
          <ul>
            <li>CRM Software</li>
            <li>Virus & Spyware Protection</li>
            <li>Backup Solutions</li>
            <li>Microsoft Products</li>
          </ul>
        </div>
      </div>
    </section>

    <section className="products-section">
      <h2>Hardware & Software Products</h2>
      <div className="products-grid">
        <div className="product-category">
          <h3>Hardware</h3>
          <ul>
            <li>Servers</li>
            <li>Workstations</li>
            <li>Laptops</li>
            <li>Network Switches</li>
            <li>Printers & Scanners</li>
            <li>POS Stations</li>
            <li>Backup Devices</li>
          </ul>
        </div>
        <div className="product-category">
          <h3>Accounting Software</h3>
          <p className="proadvisor-badge">QuickBooks ProAdvisor</p>
          <ul>
            <li>QuickBooks Desktop Setup & Training</li>
            <li>QuickBooks Online Configuration</li>
            <li>Data Migration & Conversion</li>
            <li>Ongoing QuickBooks Support</li>
          </ul>
        </div>
      </div>
    </section>

    <section className="cta-section">
      <h2>Get a Technology Assessment</h2>
      <p>
        Not sure what IT solutions your business needs? Contact us for a free technology 
        assessment. We'll evaluate your current setup and recommend solutions that fit 
        your budget and goals.
      </p>
      
      <div className="contact-info-inline">
        <address className="contact-address">
          <strong>Lawall Service Corp.</strong><br />
          30 Ursula Drive<br />
          Roslyn, NY 11576-3021
        </address>
        <p>
          <strong>Phone:</strong> <a href="tel:+15166259051">(516) 625-9051</a><br />
          <strong>Email:</strong> <Obfuscate email="lawall@lhcpapc.com" />
        </p>
      </div>
      
      <Link to="/contact/" className="btn btn-primary">Request a Consultation</Link>
    </section>
  </Layout>
)

export default ComputerConsultingPage
